import type { RefObject } from 'react';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';
import gsap from 'gsap';
import { findTransitionController } from '../../../util/core-transition-component';

interface PrimaryDropdownRefs {
  elementRef: RefObject<HTMLElement | null>;
  labelRef: RefObject<HTMLParagraphElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, labelRef }: PrimaryDropdownRefs,
): void {
  const labelController = findTransitionController(labelRef);

  if (elementRef?.current) {
    timeline.fromTo(
      elementRef.current,
      { scaleX: 0.4 },
      { duration: 0.5, scaleX: 1, ease: 'Expo.easeOut', clearProps: 'scale' },
      0,
    );
    timeline.add(fadeFromTo(elementRef.current as HTMLElement), 0);
  }

  if (labelController) {
    timeline.add(labelController.getTimeline('in') as gsap.core.Timeline, 0);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: PrimaryDropdownRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}

export function openDropdown(listRef: RefObject<HTMLUListElement | null>, open = true): void {
  gsap.to(listRef.current, { height: open ? 'auto' : 0, duration: 0.3, ease: 'Quad.easeInOut' });
}
